(() => {
  console.log("%c👍🏼 Default Carousel", "color: yellow");
  const defaultCarousels = document.querySelectorAll(".default-carousel");
  if (!defaultCarousels.length || !window.KeenSlider) return;

  defaultCarousels.forEach((carousel) => {
    const prevBtn = carousel.querySelector('[data-arrow="left"]');
    const nextBtn = carousel.querySelector('[data-arrow="right"]');
    const arrowContainer = prevBtn ? prevBtn.parentElement : nextBtn ? nextBtn.parentElement : null;
    const desktopQuery = window.matchMedia('(min-width: 1280px)');
    const slider = new KeenSlider(carousel.querySelector(".keen-slider"), {
      slides: {
        perView: 1.33,
        spacing: 15,
      },
      breakpoints: {
        "(min-width: 768px)": {
          slides: {
            perView: 2.33,
            spacing: 15
          },
        },
        "(min-width: 1280px)": {
          slides: {
            perView: 3.3,
            spacing: 15
          },
        },
        "(min-width: 1536px)": {
          slides: {
            perView: 3.66,
            spacing: 15
          },
        },
         "(min-width: 2048px)": {
          slides: {
            perView: 4.3,
            spacing: 15
          },
        }
      },
      created(s) {
        // Create dots based on snap points
        // Nav buttons
        if (prevBtn) prevBtn.addEventListener("click", () => s.prev());
        if (nextBtn) nextBtn.addEventListener("click", () => s.next());
        updateArrows(s);
      },
      slideChanged(s) {
        updateArrows(s);
      },
      updated(s) {
        updateArrows(s);
      },
    });
    window.addEventListener('resize', () => updateArrows(slider));

    function updateArrows(s) {
      if (arrowContainer) {
        const fitsOnDesktop = desktopQuery.matches && s.track.details.maxIdx === 0;
        arrowContainer.style.visibility = fitsOnDesktop ? 'hidden' : '';
      }
      if (prevBtn) prevBtn.disabled = s.track.details.rel === 0;
      const lastIdx = s.track.details.maxIdx;
      if (nextBtn) nextBtn.disabled = s.track.details.rel === lastIdx;
    }
  });
})();
